"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
const react_1 = __importDefault(require("react"));
const TokenList_1 = __importDefault(require("../../utils/dom/TokenList"));
const variables_1 = require("../../variables");
require("./List.css");
require("./Paragraph.css");
exports.default = react_1.default.memo(function List(props) {
    if (props.ordered) {
        return (react_1.default.createElement("ol", Object.assign({}, props, { className: TokenList_1.default.join([variables_1.StyleNamespace, 'List', props.className]) })));
    }
    else {
        return (react_1.default.createElement("ul", Object.assign({}, props, { className: TokenList_1.default.join([variables_1.StyleNamespace, 'List', props.className]) })));
    }
});
exports.ListItem = react_1.default.memo(function (props) {
    return (react_1.default.createElement("li", Object.assign({}, props, { className: TokenList_1.default.join([variables_1.StyleNamespace, 'ListItem', props.className]) })));
});
